export default __webpack_public_path__ + "static/media/365 steak badge.a9cda74d.svg";